import {Component, inject, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ModalCadastroVisualizacaoVariavelComponent} from './modal-cadastro-visualizacao-variavel/modal-cadastro-visualizacao-variavel.component';
import { Variavel } from '../shared/model/variavel/variavel.model';
import {FormFieldComponent} from '../shared/components/form-field/form-field.component';
import {TituloRotinaComponent} from '../shared/components/app-titulo/titulo-component';
import {VariavelService} from '../shared/service/variavel.service';
import {ButtonPadraoComponent} from '../shared/components/button-padrao/button-padrao.component';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {TipoVariavel} from '../shared/enum/tipo-variavel.enum';
import {DatePipe} from '@angular/common';
import {MsgService} from '../shared/service/msg.service';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ValidacaoAlteracaoCampoService} from '../shared/service/utilitarios/validacao-alteracao-campo.service';

@Component({
  selector: 'app-variavel',
  standalone: true,
  imports: [
    FormFieldComponent,
    TituloRotinaComponent,
    ButtonPadraoComponent,
    MatTableModule,
    MatTooltipModule,
    DatePipe,
  ],
  templateUrl: './variavel.component.html',
  styleUrl: './variavel.component.css'
})
export class VariavelComponent implements OnInit {
  variaveis: Variavel[] = [];
  variaveisDataSource = new MatTableDataSource<Variavel>();
  variaveisCarregadas = false;
  displayedColumns: string[] = ['acao', 'nome', 'tipo', 'status', 'isPesquisa', 'usuCriacao', 'dataCriacao', 'usuAlteracao', 'dataAlteracao'];

  private readonly variavelService = inject(VariavelService);
  private readonly dialog = inject(MatDialog);
  private readonly msgService = inject(MsgService);
  private readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);

  ngOnInit() { this.buscarVariaveis(); }

  buscarVariaveis() {
    this.variavelService.buscarVariaveisPeloGrupo().subscribe({
      next: res => {
        this.variaveisCarregadas = false;
        this.variaveis = res;
        this.variaveisDataSource = new MatTableDataSource(this.variaveis);
      },
      complete: () => {
        this.variaveisCarregadas = true;
      }
    });
  }

  filtrarVariaveis(event: string) {
    this.variaveisDataSource = new MatTableDataSource(this.variaveis.filter(vari => vari.nome!.toLowerCase().includes(event.toLowerCase())));
  }

  abrirModal(visualizar: boolean, variavel?: Variavel) {
    let variavelObj;
    if(variavel){
      variavelObj = JSON.parse(JSON.stringify(variavel)) as Variavel;
    }else{
      variavelObj = new Variavel()
    }
    const dialogRef = this.dialog.open(ModalCadastroVisualizacaoVariavelComponent, {
      width: '361px', height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: { visualizar, variavel: variavelObj },
      panelClass: 'slide-modal',
      disableClose: !visualizar
    })

    if (!visualizar) {
      dialogRef.backdropClick().subscribe(() => {
        const podeFechar = !this.alteracaoService.isCamposAlteracao() ||
          window.confirm('Pode possuir alterações não salvas, deseja fechar?');
        if (podeFechar) {
          dialogRef.close();
        }
      });
    }

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res) {
          this.variavelService.salvarVariavel(res).subscribe({
            next: () => {
              this.buscarVariaveis();
              this.msgService.msgSucesso('Variável salva com sucesso.');
            }
          });
        }
      }
    });
  }

  getLabel(key: string): string {
    return TipoVariavel[key as keyof typeof TipoVariavel];
  }
}
